export default{
    "C++": {
      name:"C++", category:"lang"
    },
    "C":{
      name:"C", category:"lang"
    },        
    "C#": {
      name:"C#", category:"lang"
    },
    "Objective-C": {
      name:"Objective-C", category:"lang"
    },    
    "Java": {
      name:"Java", category:"lang"
    },
    "JavaScript": {
      name:"JavaScript", category:"lang"
    },
    "PHP": {
      name:"PHP", category:"lang"
    },
    "Go": {
      name:"Go", category:"lang"
    },
    "Python": {
      name:"Python", category:"lang"
    },
    "Haskell": {
      name:"Haskell", category:"lang"
    },
    "Perl": {
      name:"Perl", category:"lang"
    },   
    "Zephir": {
      name:"Zephir", category:"lang"
    },        
    "MATLAB": {
      name:"MATLAB", category:"lang"
    },                  
    "Prolog": {
      name:"Prolog", category:"lang"
    },
    "HLSL": {
      name:"HLSL", category:"lang"
    },
    "GLSL": {
      name:"GLSL", category:"lang"
    },        
    "HTML":{
      name:"HTML", category:"lang"
    },
    "css": {
      name:"css", category:"lang"
    },
    "sass": {
      name:"sass", category:"lang"
    },
    "SQL": {
      name:"SQL", category:"lang"
    },             
    "DirectX": {
      name:"DirectX", category:"framework"
    },
    "Windows API": {
      name:"Windows API", category:"framework"
    },
    "OpenSiv3D": {
        name:"Siv3D", category:"framework"
    },    
    "Siv3D": {
      name:"Siv3D", category:"framework"
    },
    "Unreal Engine": {
      name:"Unreal Engine", category:"framework"
    },    
    "Unity": {
      name:"Unity", category:"framework"
    },
    "cocos2d-x": {
      name:"cocos2d-x", category:"framework"
    },            
    "CocosCreater":{
      name:"CocosCreater", category:"framework"
    },
    "Phalcon": {
      name:"Phalcon", category:"framework"
    },
    "Laravel": {
      name:"Laravel", category:"framework"
    },
    "Vue.js": {
      name:"Vue.js", category:"framework"
    },
    "Capacitor": {
      name:"Capacitor", category:"framework"
    },
    "MySQL" :{
      name:"MySQL", category:"db"
    },
    "SQLite":{
      name:"SQLite", category:"db"
    },
    "Redis": {
      name:"Redis", category:"db"
    },     
    "Docker": {
      name:"Docker", category:"container"
    },    
    "Vagrant": {
      name:"Vagrant", category:"container"
    },             
    "AWS" :{
      name:"AWS", category:"cloud"
    },
    "GitHub Actions":{
      name:"GitHub Actions", category:"cicd"
    },       
    "CircleCI":{
      name:"CircleCI", category:"cicd"
    },   
    "Git": {
      name:"Git", category:"vcs"
    },
    "SVN": {
      name:"SVN", category:"vcs"
    },
    "Unity Version Control": {
      name:"Unity Version Control", category:"vcs"
    },
    "Perforce": {
      name:"Perforce", category:"vcs"
    },        
    "Visual Studio": {
      name:"Visual Studio", category:"edit"
    },
    "VS Code": {
      name:"VS Code", category:"edit"
    },
    "IntelliJ": {
      name:"IntelliJ", category:"edit"
    },   
    "Android Studio": {
      name:"Android Studio", category:"edit"
    },
    "XCode": {
      name:"XCode", category:"edit"
    },            
    "Windows": {
      name:"Windows", category:"platform"
    },            
    "Mac": {
      name:"Mac", category:"platform"
    },            
    "Linux": {
      name:"Linux", category:"platform"
    },            
    "Android": {
      name:"Android", category:"platform"
    },            
    "iOS": {
      name:"iOS", category:"platform"
    },            
    "Nintendo Switch": {
      name:"Nintendo Switch", category:"platform"
    },     
    "Web": {
      name:"Web", category:"platform"
    } ,      
    "AR": {
      name:"AR", category:"device"
    },            
    "Tobii EyeX": {
      name:"Tobii EyeX", category:"device"
    },       
    "GitHub": {
      name:"GitHub", category:"workspace"
    },
    "Atlassian": {
      name:"Atlassian", category:"workspace"
    },
    "Google Workspace": {
      name:"Google Workspace", category:"workspace"
    },        
    "Microsoft 365": {
      name:"Microsoft 365", category:"workspace"
    },       
    "Discord": {
      name:"Discord", category:"workspace"
    },       
    "Slack": {
      name:"Slack", category:"workspace"
    },   
    "Notion": {
      name:"Notion", category:"workspace"
    },       
    "ChatGPT": {
      name:"ChatGPT", category:"workspace"
    },    
};